import { call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_DAILY_MOVE_IQ_EVENTS,
    FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING,
    FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS,
    FETCH_DAILY_MOVE_IQ_EVENTS_FAIL,
    DELETE_MOVE_IQ_EVENT,
    DELETE_MOVE_IQ_EVENT_SUCCESS,
    DELETE_MOVE_IQ_EVENT_FAIL
} from '../actions/ActionTypes';
import { gcApi } from '../config/axios';

export function* fetchDailyMoveIQSaga(action) {
    const { displayName, calendarDate } = action;

    try {
        yield put({
            type: FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/wellness-service/wellness/dailyEvents/${displayName}?calendarDate=${calendarDate}`
        );

        yield put({
            type: FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS,
            moveIQEvents: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_MOVE_IQ_EVENTS_FAIL,
            moveIQEvents: [],
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* deleteMoveIQEventSaga(action) {
    const { event, calendarDate } = action;

    try {
        const response = yield call(gcApi.delete, `/wellness-service/wellness/dailyEvent/`, { data: event });

        if (response.status === 204) {
            yield put({
                type: DELETE_MOVE_IQ_EVENT_SUCCESS,
                event: event,
                calendarDate: calendarDate,
                displayName: action.displayName
            });
        } else {
            yield put({
                type: DELETE_MOVE_IQ_EVENT_FAIL,
                event: event,
                calendarDate: calendarDate,
                displayName: action.displayName
            });
        }
    } catch (e) {
        yield put({
            type: DELETE_MOVE_IQ_EVENT_FAIL,
            event: event,
            calendarDate: calendarDate,
            displayName: action.displayName
        });
    }
}

export const moveIQSagas = [
    takeEvery(FETCH_DAILY_MOVE_IQ_EVENTS, fetchDailyMoveIQSaga),
    takeEvery(DELETE_MOVE_IQ_EVENT, deleteMoveIQEventSaga)
];
